import { useMemo } from 'react';
import { Menu } from "@/types";
import { Button, Paper, Stack, Typography, useTheme } from "@mui/material";
import { MoveRight, Utensils } from "lucide-react";
import { useAppSelector } from  '@/hooks';

type Props = Pick<Menu, 'title' | 'createdBy' | 'lastUpdatedAt'> & {
    onClick: () => void;
};

const MenuCard = ({ title, createdBy, onClick }: Props) => {
    const theme = useTheme();
    const users = useAppSelector((state) => state.users);

    const author = useMemo(() => {
        return users[createdBy]?.name ?? '...'
    }, [createdBy, users])
    
    return (
        <Paper elevation={0} sx={{ borderRadius: 4, overflow: 'hidden' }}>
            <Stack
                padding={2}
                alignItems="center"
                sx={{ backgroundColor: theme.palette.secondary.main }}
            >
                <Utensils color="white" />
            </Stack>
            <Stack padding={2} gap={1}>
                <Typography variant="h3">{title}</Typography>
                <Stack gap={2} direction="row" justifyContent="space-between" alignItems="center" >
                    <Typography variant="caption" noWrap flex={1}>{author}</Typography>
                </Stack>
                <Stack direction="row" justifyContent="flex-end">
                    <Button
                        color="success"
                        onClick={onClick}
                    >
                        <MoveRight />
                    </Button>
                </Stack>
            </Stack>
        </Paper>
    );
}

export default MenuCard;
